export function inviteMembersReducer(state, action) {
  switch (action.type) {
    case "setMembers":
      return {
        ...state,
        members: action.members,
        selectedMemberIds:
          action.members == null ? [] : action.members.map((item) => item.id),
      };
    case "setSelected":
      return {
        ...state,
        selectedMemberIds: action.memberIds,
      };
    default:
      throw new Error();
  }
}
